export function formatOffset(offsetInMinutes: number): string {
  const hours = Math.floor(Math.abs(offsetInMinutes) / 60)
  const minutes = Math.abs(offsetInMinutes) % 60
  const sign = offsetInMinutes >= 0 ? '+' : '-'

  return `GMT${sign}${hours}:${minutes.toString().padStart(2, '0')}`
}
